var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDevstudio(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2 2H14V14H2V2ZM5.05719 6.5L4.0286 5.4714L4.9714 4.5286L6.94281 6.5L4.9714 8.4714L4.0286 7.5286L5.05719 6.5ZM7.33333 8.33333H9.66667V7H7.33333V8.33333Z",
    fill: "#2B2F33"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDevstudio);
export default __webpack_public_path__ + "static/media/devstudio.849668777a9466cef36ab8a0a94c088c.svg";
export { ForwardRef as ReactComponent };